import React, { useState, useEffect, useCallback, useImperativeHandle } from 'react';
import { Box, ButtonBase, Grid, makeStyles, Typography } from '@material-ui/core';
import _ from 'lodash';
import { connect, useSelector } from 'react-redux';
import moment from 'moment';
import { bedStatusAPI } from '../../../../apis';
import { AutoCompleteSelect, ColumnItem } from '../../../../components';
import {
  AdmIcon,
  MissingIcon,
  BedAvailableIcon,
  DischgIcon,
  OccupiedIcon,
  FilterIcon,
  CloseIcon,
  // OutstandingIcon,
  HomeLeaveIcon,
  // PendingFYAIcon,
} from '../../../../components/Icon';
import { i18n } from '../../../../language';
import bs, { statusP } from '../../bsApp';
import { baseCssBedStatus } from '../baseCss/baseCssBedStatus';
import RemaksIcon from '../BedStatusIcon/RemaksIcon';
import ChooseFilter from '../PopWindows/ChooseFilter';
import TitleBedStatus from '../TitleBedStatus';
import BottonStatusIcon from '../BedStatusIcon/BottonStatusIcon';
import { BEDSTATUS_CHOOSE_FILTER, BEDSTATUS_OUTSTANDING_TRANSFER_IN } from '../../../../comm/constant';
import { isRequest } from '../../../../utils';
import { alertMsg, ResponseCommCodeEnum } from '../../../../apis/commlogic';
import eventBus from '../../../../utils/eventBus';
import { useActionableTicketReminder } from '../../../../utils/hooks';
import { MuteBtn } from '../../../Admission/Actionable/ActionableHeader';
import { bedstatusRef } from '../..';
import { bsFilterFunc } from './filterFunc';

const reA = /[^a-zA-Z]/g;
const reN = /[^\D]/g;

function sortAlphaNum(a, b) {
  const aA = a.replace(reA, '');
  const bA = b.replace(reA, '');
  if (aA === bA) {
    let aN = parseInt(a.replace(reN, ''), 10);
    let bN = parseInt(b.replace(reN, ''), 10);
    if (aN === bN) return 0;
    if (aN > bN) return 1;
    return -1;
  } else {
    return aA > bA ? 1 : -1;
  }
}

const SelectCtr = ({ setFilterData, useStyle, filterData, openChooseFilterPop, wardList, wards, selectChange }) => {
  const selectAllHandle = () => {
    const filterObj = bsFilterFunc.setDefaultFilter();
    setFilterData(filterObj);
  };

  return (
    <div className={useStyle.autoCompleteSelect}>
      <Box mr="0.938rem">
        <MuteBtn bedstatus={true} />
      </Box>
      {bsFilterFunc.isSelectAll({ allData: filterData }) ? (
        <ButtonBase id="bed_filter_btn1" className={useStyle.filter} onClick={openChooseFilterPop}>
          <FilterIcon className={useStyle.filterIcon} />
          {i18n.t('BEDSTATUS_FILTER')}
        </ButtonBase>
      ) : (
        <div className={useStyle.filterBox}>
          <ButtonBase id="bed_filter_btn1" className={useStyle.filterAll} onClick={openChooseFilterPop}>
            <FilterIcon className={useStyle.filterIconAll} />
            {i18n.t('BEDSTATUS_FILTER')}
          </ButtonBase>
          <ButtonBase id="bed_filter_btn2" style={{ padding: '0 1rem' }} onClick={selectAllHandle}>
            <CloseIcon className={useStyle.closeIcon} />
          </ButtonBase>
        </div>
      )}
      <AutoCompleteSelect
        id="bed_filter_select1"
        itemList={[{ text: 'All', value: '' }, ...wardList]}
        width="9.375rem"
        height="2.938rem"
        value={wards}
        onChange={selectChange}
      />
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  root: ({ sso }) => ({
    position: 'relative',
    margin: sso ? '0' : '0 3.375rem 0',
    background: '#fff',
    borderRadius: '0 0.937rem 0.937rem 0.937rem',
    paddingTop: '1px',
    overflowY: 'auto',
    overflowX: 'hidden',
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
  }),
  columnBox: {
    margin: '1.875rem 1.875rem 0',
    padding: '0 1.563rem',
    border: 'solid 1.2px #e4e7eb',
    borderRadius: '0.937rem',
  },
  autoCompleteSelect: {
    display: 'flex',
    margin: '0 1.875rem 0',
  },
  filter: {
    width: '6.75rem',
    height: '2.938rem',
    borderRadius: '0.5rem',
    border: 'solid 1px #e4e7eb',
    marginRight: '0.938rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
    color: '#7d86a9',
  },
  filterBox: {
    display: 'flex',
    background: '#538fff',
    marginRight: '0.938rem',
    border: 'solid 1px #e4e7eb',
    borderRadius: '0.5rem',
  },
  filterAll: {
    width: '6.25rem',
    height: '2.938rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
    color: '#fff',
  },
  filterIconAll: {
    width: '1.438rem',
    height: '1.438rem',
    color: '#fff',
    marginRight: '0.625rem',
  },
  closeIcon: {
    width: '1rem',
    height: '1rem',
    color: '#fff',
  },
  filterIcon: {
    width: '1.438rem',
    height: '1.438rem',
    color: '#538fff',
    marginRight: '0.625rem',
  },
  bedRoot: {
    display: 'flex',
    flexDirection: 'column',
  },
  bottom: {
    padding: '0.875rem 3.5rem',
    backgroundColor: '#fff',
  },
  laseUpdateTime: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
    color: '#7d86a9',
    margin: '1rem 1rem 1rem 3.125rem',
  },
  headerBox: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
    overflowY: 'auto',
    overflowX: 'hidden',
    position: 'relative',
  },
  unmuteBox: {
    display: 'flex',
    background: '#f5faff',
    marginRight: '0.938rem',
    border: 'solid 1px #e4e7eb',
    borderRadius: '0.5rem',
  },
  unmuteAll: {
    width: '6.875rem',
    height: '2.938rem',
    color: '#538fff',
  },
  unmuteIconAll: {
    width: '1.5rem',
    height: '1.5rem',
    color: '#538fff',
    marginRight: '0.625rem',
  },

  title: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#7d86a9',
    marginBottom: '1rem',
    fontWeight: '500',
  },
  box: {
    display: 'flex',
    alignItems: 'center',
  },
  iconFYA: {
    width: '1.875rem',
    height: '1.875rem',
    color: '#ffffff',
    padding: '0.25rem',
    marginRight: '0.938rem',
    borderRadius: '0.312rem',
    backgroundColor: '#f40300',
  },
  text: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.875rem',
    fontWeight: 'bold',
    color: '#2e4469',
    lineHeight: '1.875rem',
  },
  buttonBaseFYA: {
    borderRadius: '12px',
    margin: '0.75rem 0',
    padding: '0.813rem 0.75rem',
  },
  buttonBaseFYABg: {
    backgroundColor: '#fff3bb',
  },
}));

const iconBgColors = ['#00a8f9', '#ff655c', '#fcb836', '#28d2ab', '#28d2ab', '#5cd9f4', '#f40300'];

function BedStatusAll({ userRole, loginInfo, tabHandler }) {
  useActionableTicketReminder('msg', 'BS');
  const filterHandle = (key) => {
    return () => {
      const newFilterData = bsFilterFunc.clickFilter({ allData: filterData, keys: key });
      setFilterData(newFilterData);
    };
  };

  const column = [
    // { id: 1, title: i18n.t('BEDSTATUS_ADM_FROM'), IconCom: AdmIcon, idName: 'bed_tool_btn1' },
    // { id: 2, title: i18n.t('BEDSTATUS_DISCHG_FROM'), IconCom: DischgIcon, idName: 'bed_tool_btn2' },
    {
      id: 1,
      title: i18n.t('BEDSTATUS_DISCHG_FROM'),
      IconCom: AdmIcon,
      DischgIcon: DischgIcon,
      dischgIconColor: '#7b80ff',
      idName: 'bed_tool_btn1',
    },
    {
      id: 2,
      title: i18n.t('BEDSTATUS_OCCUPIED'),
      IconCom: OccupiedIcon,
      onClick: filterHandle(bs.OCCUPIED),
      idName: 'bed_tool_btn2',
    },

    {
      id: 3,
      title: i18n.t('BEDSTATUS_MISSING'),
      IconCom: MissingIcon,
      onClick: filterHandle([bs.MISSING, bs.MISSING_CLOSED]),
      idName: 'bed_tool_btn3',
    },
    {
      id: 4,
      title: i18n.t('BEDSTATUS_BED_AVAILABLE'),
      IconCom: BedAvailableIcon,
      idName: 'bed_tool_btn4',
    },
    {
      id: 5,
      title: i18n.t('BEDSTATUS_HOME_LEAVE'),
      IconCom: HomeLeaveIcon,
      onClick: filterHandle([bs.HOME_LEAVE, bs.HOME_LEAVE_OVERTIME]),
      idName: 'bed_tool_btn5',
    },
    // {
    //   id: 6,
    //   idName: 'bed_tool_btn6',
    //   title: i18n.t('BEDSTATUS_OUTSTANDING_TRANSFER_IN'),
    //   IconCom: OutstandingIcon,
    //   onClick: () => {
    //     tabHandler(1);
    //     sessionStorage.setItem(
    //       BEDSTATUS_OUTSTANDING_TRANSFER_IN,
    //       JSON.stringify({
    //         startTime: '2021-01-01 00:00:00',
    //         stopTime: moment().add(6, 'days').format('yyyy-MM-DD 23:59:59'),
    //         status: ['O'],
    //       })
    //     );
    //   },
    // },
    // {
    //   id: 8,
    //   idName: 'bed_tool_btn8',
    //   title: 'Pending FYA transfer in',
    //   IconCom: PendingFYAIcon,
    //   onClick: () => {
    //     tabHandler(1);
    //     sessionStorage.setItem(
    //       BEDSTATUS_OUTSTANDING_TRANSFER_IN,
    //       JSON.stringify({
    //         startTime: '2021-01-01 00:00:00',
    //         stopTime: moment().add(6, 'days').format('yyyy-MM-DD 00:00:00'),
    //         status: 'O',
    //       })
    //     );
    //   },
    // },
  ];
  const [columnValue, setColumnValue] = useState(null);
  const [dischgCount, setDischgCount] = useState(null);
  const remarks = [
    { typeName: bs.MISSING, text: i18n.t('BEDSTATUS_MISSING'), idName: 'bed_navigation_btn1' },
    { typeName: bs.MISSING_CLOSED, text: i18n.t('BEDSTATUS_MISSING_CLOSED_CASE'), idName: 'bed_navigation_btn2' },
    { typeName: bs.DAY_BED, text: i18n.t('BEDSTATUS_DAY_BED'), idName: 'bed_navigation_btn3' },
    { typeName: bs.ADDED_BED, text: i18n.t('BEDSTATUS_ADDED_BED'), idName: 'bed_navigation_btn4' },
    { typeName: bs.ATTENTION, text: i18n.t('BEDSTATUS_ATTENTION'), idName: 'bed_navigation_btn5' },
    { typeName: bs.NEATS, text: i18n.t('BEDSTATUS_NEATS'), idName: 'bed_navigation_btn6' },
    {
      typeName: bs.BASIC_CLEANSING,
      typeName2: bs.BASIC_CLEANSING_ONGOING,
      text: i18n.t('BEDSTATUS_BASIC_CLEANSING'),
      idName: 'bed_navigation_btn7',
    },
    {
      typeName: bs.TERMINAL_DISINFECTION,
      typeName2: bs.TERMINAL_DISINFECTION_ONGOING,
      text: i18n.t('BEDSTATUS_TERMINAL_DISINFECTION'),
      idName: 'bed_navigation_btn8',
    },
    {
      typeName: bs.PENDING_ADMISSION,
      typeName2: bs.RETURN_DAY_CASE,
      text: `${i18n.t('BEDSTATUS_PENDING_ADMISSION')}/${i18n.t('BEDSTATUS_RETURN_DAY_CASE')}`,
      idName: 'bed_navigation_btn9',
    },
    { typeName: bs.RESUSITATION, text: i18n.t('BEDSTATUS_RESUSITATION'), idName: 'bed_navigation_btn10' },
    { typeName: bs.MAINTANIENCE, text: i18n.t('BEDSTATUS_MAINTANIENCE'), idName: 'bed_navigation_btn11' },
    {
      typeName: bs.LIFE_SAVING_EQUIPMENT,
      text: i18n.t('BEDSTATUS_LIFE_SAVING_EQUIPMENT'),
      idName: 'bed_navigation_btn12',
    },
    { typeName: bs.AIRBORNE_PRECAUTION, text: i18n.t('BEDSTATUS_AIRBORNE_PRECAUTION'), idName: 'bed_navigation_btn13' },
    { typeName: bs.DROPLET_PRECAUTION, text: i18n.t('BEDSTATUS_DROPLET_PRECAUTION'), idName: 'bed_navigation_btn14' },
    { typeName: bs.CONTACT_PRECAUTION, text: i18n.t('BEDSTATUS_CONTACT_PRECAUTION'), idName: 'bed_navigation_btn15' },
    { typeName: bs.REVERSE_LSOLATION, text: i18n.t('BEDSTATUS_REVERSE_LSOLATION'), idName: 'bed_navigation_btn16' },
    { typeName: bs.COVID_19, text: i18n.t('BEDSTATUS_COVID_19'), idName: 'bed_navigation_btn17' },
    {
      typeName: bs.MDRO_CONTACT,
      typeName2: bs.MDRO_CONFIRMED,
      text: 'MDRO(Contact)/(Confirmed)',
      idName: 'bed_navigation_btn23',
    }, // MDRO
    { typeName: bs.CMS_ALERT, text: i18n.t('CMS_ALERT'), idName: 'bed_navigation_cms_alert' },
    { typeName: bs.HOME_LEAVE, text: i18n.t('BEDSTATUS_HOME_LEAVE'), idName: 'bed_navigation_btn18' },
    {
      typeName: bs.HOME_LEAVE_OVERTIME,
      text: i18n.t('BEDSTATUS_HOME_LEAVE_OVERTIME'),
      idName: 'bed_navigation_btn19',
    },
    {
      typeName: bs.TO,
      text: i18n.t('BEDSTATUS_TRANSFER_OUT'),
      idName: 'bed_navigation_btn20',
    },
    { typeName: bs.FROZEN, text: 'Frozen', idName: 'bed_navigation_btn22' },
    { typeName: bs.ELDERLY_HOME, text: i18n.t('ELDERLY_HOME'), idName: 'bed_navigation_elderly_home' },
  ];

  const statusBottom = [
    { typeName: bs.AVAILABLE, text: i18n.t('BEDSTATUS_VACANT'), idName: 'bed_navigation_btn17' },
    { typeName: bs.OCCUPIED, text: i18n.t('BEDSTATUS_OCCUPIED'), idName: 'bed_navigation_btn18' },
    { typeName: bs.DISCHARGING, text: i18n.t('BEDSTATUS_DISCHARGING'), idName: 'bed_navigation_btn19' },
    { typeName: bs.TBC, text: i18n.t('BEDSTATUS_TBC'), idName: 'bed_navigation_btn20' },
    { typeName: bs.UNAVAILABLE, text: i18n.t('BEDSTATUS_UNAVAILABLE'), idName: 'bed_navigation_btn21' },
  ];

  const classes = baseCssBedStatus();
  const sso = useSelector((state) => state.ssoReducer);
  const useStyle = useStyles({ sso });
  const rouList = useSelector((state) => state.rouList);

  const [wards, setWards] = useState('');
  const [BedStatusList, setBsBedStatusList] = useState([]);
  const [lastUpdateTime, setLastUpdateTime] = useState(null);
  const [wardList, setWardList] = useState([]);

  const getBsBedStatusList = async (callBack) => {
    const { result } = await bedStatusAPI.postBsBedStatusList(
      {
        wardId: loginInfo.wardId,
        searchFields: [
          {
            key: 'ccWardCd',
            value: wards,
          },
          ...bsFilterFunc.getAllTrueValue(filterData),
        ],
      },
      { isHideLoading: true }
    );
    callBack?.();
    if (Array.isArray(result?.BedStatusInfo)) {
      const BedStatusInfo = result?.BedStatusInfo;
      const BedStatusInfoTmp = _.chain(BedStatusInfo)
        .sort((a, b) => sortAlphaNum(a.ccWardCd, b.ccWardCd))
        .value();
      setBsBedStatusList(BedStatusInfoTmp);
    } else {
      setBsBedStatusList([]);
    }
    setColumnValue([
      result?.admCount ?? 0,
      result?.occupiedCount ?? 0,
      result?.missingCount ?? 0,
      result?.bedAvailableCount ?? 0,
      result?.homeLeaveCount ?? 0,
      result?.outStandingCount ?? 0,
    ]);
    setDischgCount(result?.dischgCount ?? 0);
    if (Array.isArray(result?.ccWardCds)) {
      const ccWardCdTmp = _.chain(result?.ccWardCds).sort(sortAlphaNum).value();
      setWardList(
        ccWardCdTmp.map((item) => {
          return { text: item, value: item };
        })
      );
    } else {
      setWardList([]);
    }
    setLastUpdateTime(result?.lastUpdatedDate);
  };

  useImperativeHandle(bedstatusRef, () => ({
    reload: getBsBedStatusList,
  }));

  const [filterData, setFilterData] = useState(null);
  const [initFulter, setInitFulter] = useState(false);
  useEffect(() => {
    if (filterData) {
      setInitFulter(true);
      (async () => {
        await requestHttp();
      })();
      sessionStorage.setItem(BEDSTATUS_CHOOSE_FILTER, JSON.stringify(filterData));
    } else {
      const session = sessionStorage.getItem(BEDSTATUS_CHOOSE_FILTER);
      if (session) {
        const obj = JSON.parse(session);
        setFilterData(obj);
      } else {
        const filterObj = bsFilterFunc.setDefaultFilter();

        setFilterData(filterObj);
      }
    }
  }, [filterData, wards]);

  const requestHttp = async () => {
    try {
      await getBsBedStatusList();
    } catch (error) {
      console.log(`-----${error}-----`);
    }
  };

  useEffect(() => {
    if (filterData) {
      const timer = setInterval(() => {
        (async () => {
          await requestHttp();
        })();
      }, 300000);
      return () => {
        clearInterval(timer);
      };
    }
  }, [filterData]);

  useEffect(() => {
    if (isRequest(loginInfo, userRole) && initFulter) {
      setFilterData(null);
      sessionStorage.removeItem(BEDSTATUS_CHOOSE_FILTER);
    }
  }, [rouList]);

  const selectChange = (data) => {
    setWards(data);
  };

  const updateBedStatus = async (data, closePop) => {
    try {
      await bedStatusAPI.postUpdateStatus(data);
      try {
        await getBsBedStatusList(closePop);
      } catch {
        closePop();
      }
    } catch (e) {
      if (e.statusCode === ResponseCommCodeEnum.BED_VERSION) {
        await getBsBedStatusList();
        alertMsg(
          i18n.t(
            'BEDSTATUS_BED_STATUS_OF_THIS_BED_WAS_CHANGED_BY_OTHER_WARDPLACE_USER_OR_IPAS_PLEASE_REFRESH_WEB_PAGE_TO_GET_THE_LATEST_BED_STATUS_INFO_AND_CHECK_IF_FURTHER_ACTION_IS_REQUIRED'
          ),
          _.uniqueId('warning_'),
          'warning'
        );
      }
    }
  };

  const saveBedStatus = async (data, closePop) => {
    try {
      await bedStatusAPI.postSaveRemark({ ...data, ccWardCd: data.wardCd });
      try {
        await getBsBedStatusList(closePop);
      } catch {
        closePop();
      }
    } catch (e) {
      if (e.statusCode === ResponseCommCodeEnum.BED_VERSION) {
        await getBsBedStatusList();
        alertMsg(
          i18n.t(
            'BEDSTATUS_BED_STATUS_OF_THIS_BED_WAS_CHANGED_BY_OTHER_WARDPLACE_USER_OR_IPAS_PLEASE_REFRESH_WEB_PAGE_TO_GET_THE_LATEST_BED_STATUS_INFO_AND_CHECK_IF_FURTHER_ACTION_IS_REQUIRED'
          ),
          _.uniqueId('warning_'),
          'warning'
        );
      }
    }
  };
  const saveReturnDayCase = async (data, closePop) => {
    try {
      await bedStatusAPI.postSaveReturnDayCase(data);
      try {
        await getBsBedStatusList();
      } catch (error) {}
    } catch (error) {}
  };
  const onListener = useCallback(() => {
    eventBus.on('BSRELOAD', getBsBedStatusList);
  }, [getBsBedStatusList]);

  const offListener = useCallback(() => {
    eventBus.off('BSRELOAD', getBsBedStatusList);
  }, [getBsBedStatusList]);
  useEffect(() => {
    onListener();

    return () => offListener();
  }, [onListener, offListener]);
  const showAllBedStatus = () => {
    return BedStatusList?.length > 0 ? (
      _.map(BedStatusList, (item, index) => {
        return item?.wardBeds?.length > 0 ? (
          <TitleBedStatus
            row={index}
            key={item.ccWardCd}
            title={item.ccWardCd}
            allBedStatus={BedStatusList[index].wardBeds}
            updateBedStatus={updateBedStatus}
            saveBedStatus={saveBedStatus}
            saveReturnDayCase={saveReturnDayCase}
            rightChild={
              index === 0 ? (
                <SelectCtr
                  setFilterData={setFilterData}
                  useStyle={useStyle}
                  filterData={filterData}
                  openChooseFilterPop={openChooseFilterPop}
                  wardList={wardList}
                  wards={wards}
                  selectChange={selectChange}
                />
              ) : null
            }
          />
        ) : (
          <div />
        );
      })
    ) : (
      <TitleBedStatus
        rightChild={
          <SelectCtr
            setFilterData={setFilterData}
            useStyle={useStyle}
            filterData={filterData}
            openChooseFilterPop={openChooseFilterPop}
            wardList={wardList}
            wards={wards}
            selectChange={selectChange}
          />
        }
      />
    );
  };

  const [ChooseFilterPop, setChooseFilterPop] = useState(false);
  const openChooseFilterPop = () => {
    setChooseFilterPop(true);
  };
  const closeChooseFilterPop = () => {
    setChooseFilterPop(false);
  };
  const chooseFilterConfirm = (valueData) => {
    setFilterData(valueData);
    closeChooseFilterPop();
  };

  return (
    <>
      {ChooseFilterPop ? (
        <ChooseFilter
          open={ChooseFilterPop}
          closePop={closeChooseFilterPop}
          confirmHandle={chooseFilterConfirm}
          allData={(() => {
            const result = {};
            [...remarks, ...statusBottom].forEach((item) => {
              result[item.typeName] = item;
            });
            return result;
          })()}
        />
      ) : (
        ''
      )}
      <main className={useStyle.root}>
        <div className={useStyle.headerBox}>
          <header className={useStyle.columnBox}>
            <Grid container style={{ justifyContent: 'space-between' }}>
              {column?.map((item, index) => {
                return (
                  <ColumnItem
                    key={item.id}
                    id={item.idName}
                    // text={columnData()?.[index]}
                    text={columnValue?.[index] ?? 0}
                    IconCom={item.IconCom}
                    dischgIconColor={item.dischgIconColor}
                    DischgIcon={item.DischgIcon}
                    dischgCountText={dischgCount ?? 0}
                    title={item.title}
                    iconBgColor={iconBgColors[index]}
                    onClick={item.onClick}
                  />
                );
              })}
            </Grid>
          </header>
          {showAllBedStatus()}
        </div>
        <Typography className={useStyle.laseUpdateTime}>
          {i18n.t('BEDSTATUS_LAST_UPDATED_TIME', {
            value: lastUpdateTime ? moment(lastUpdateTime).format('yyyy-MM-DD HH:mm') : '',
          })}
        </Typography>
      </main>
      <footer className={useStyle.bottom}>
        <Typography className={classes.statusText}>{i18n.t('BEDSTATUS_STATUS')}</Typography>
        <Box display="flex" flexWrap="wrap" m="0.325rem 0px 0.125px 0px">
          {_.map(statusBottom, (item) => {
            return (
              <ButtonBase
                style={{ display: 'flex', alignItems: 'center', margin: '0 2.875rem 0 0', padding: '0.5rem 0' }}
                key={item.typeName}
                onClick={filterHandle(item.typeName)}
                id={item.idName}
              >
                <BottonStatusIcon typeName={item.typeName} />
                <Typography className={classes.vacantText}>{item.text}</Typography>
              </ButtonBase>
            );
          })}
        </Box>
        <Typography className={classes.statusText}>{i18n.t('BEDSTATUS_REMARKS')}</Typography>
        <Box display="flex" flexWrap="wrap" m="0.325rem 0px 0.125px 0px">
          {_.map(remarks, (item) => {
            return (
              <ButtonBase
                style={{ display: 'flex', margin: '0 2.875rem 0 0', padding: '0.5rem 0' }}
                key={item.typeName}
                onClick={filterHandle(item.typeName)}
                id={item.idName}
              >
                {Object.values(statusP).includes(item.typeName) ? (
                  <BottonStatusIcon typeName={item.typeName} className={classes.remaksIcon} />
                ) : (
                  <Box display="flex">
                    <RemaksIcon typeName={item.typeName} className={classes.remaksIcon} />
                    {item.typeName2 && (
                      <>
                        <div style={{ fontSize: '1.5rem', margin: '0 0.2rem' }}>/</div>
                        <RemaksIcon typeName={item.typeName2} className={classes.remaksIcon} />
                      </>
                    )}
                  </Box>
                )}
                <Typography className={classes.vacantText}>{item.text}</Typography>
              </ButtonBase>
            );
          })}
        </Box>
      </footer>
    </>
  );
}

export default connect((state) => ({
  userRole: state.userRole,
  loginInfo: state.loginInfo,
}))(BedStatusAll);
